"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcDataList = void 0;
var react_1 = __importDefault(require("react"));
var Card_1 = __importDefault(require("react-bootstrap/Card"));
var AcPagination_1 = require("../pagination/AcPagination");
var AcTable_1 = require("../table/AcTable");
var AcGrid_1 = require("./AcGrid");
var AcDataList = function (props) {
    var loading = props.loading, data = props.data, grid = props.grid, columns = props.columns, functionContext = props.functionContext, hidePagination = props.hidePagination, renderRowsOnly = props.renderRowsOnly, whenNoData = props.whenNoData, bottomActionBar = props.bottomActionBar;
    var content = (react_1.default.createElement(react_1.default.Fragment, null,
        !grid && react_1.default.createElement(AcTable_1.AcTable, __assign({}, props)),
        grid && (react_1.default.createElement(AcGrid_1.AcGrid, { column: columns[0], functionContext: functionContext, data: data, loading: loading, whenNoData: whenNoData }))));
    if (renderRowsOnly) {
        return content;
    }
    return (react_1.default.createElement(Card_1.default, { className: "rounded-0 border-0 bg-transparent" },
        react_1.default.createElement(Card_1.default.Body, { className: "p-0" },
            content,
            react_1.default.createElement("div", { className: "d-flex justify-content-center" },
                !hidePagination && !loading && data && data.length > 0 && react_1.default.createElement(AcPagination_1.AcPagination, __assign({}, props)),
                bottomActionBar && react_1.default.createElement("div", { className: "d-flex ml-auto" }, bottomActionBar)))));
};
exports.AcDataList = AcDataList;
exports.AcDataList.displayName = 'AcDataList';
//# sourceMappingURL=AcDataList.js.map